import { get } from 'lodash';

import * as apiUtil from '../apiUtils';
import * as apiCommon from '../apiCommon';
import { INTEGRATION } from '../../constants/constant_doc_types';

export function saveIntegration(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const waitingTime = get(data, 'parameters.waiting_time');

  if (waitingTime) {
    data.parameters.waiting_time = Number(waitingTime);
  }

  const integrationData = {
    doc_type: INTEGRATION,
    name: apiUtil.toStringText(data.name),
    description: !data.description
      ? null
      : apiUtil.toStringText(data.description),
    system_defined: apiUtil.toBoolean(data.system_defined),
    parameters: data.parameters,
    type: data.type,
    type_id: data.type_id,
  };
  return apiCommon.saveDoc(app, {
    source: data,
    doc: integrationData,
    user,
  });
}

export function fetchIntegrationTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'integration_type/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams: { ...searchParams },
  };

  return apiCommon.getDropdownList(app, { query });
}

export function deleteIntegration(app, params) {
  const { id } = params;
  return apiCommon.deleteDoc(app, { id: id, docType: INTEGRATION });
}
